import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  dialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
  },
  dialogTitle: {
    margin: 0,
    padding: 0,
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  dialogContent: {
    padding: theme.spacing(2, 3),
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(1),
  },
  reasonTextField: {
    width: '100%',
    marginTop: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
    },
  },
  helperText: {
    marginTop: '6px',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
  },
  cancelButton: {
    color: theme.palette.text.secondary,
    height: '44px',
  },
  submitButton: {
    height: '44px',
  }
}));

const DialogVoteReason = ({
  open,
  onClose,
  onSubmit,
  initialReason = '',
}) => {
  const classes = useStyles();
  const [reasonText, setReasonText] = useState(initialReason);

  useEffect(() => {
    if (open) {
      setReasonText(initialReason);
    }
  }, [open, initialReason]);

  const handleSubmit = () => {
    onSubmit(reasonText.trim());
    handleClose();
  };

  const handleClose = () => {
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.dialogHeader}>
        <Typography variant="h6" className={classes.dialogTitle}>
          Escusa de voto
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Typography variant="body1">
          Introduza a razão da escusa:
        </Typography>
        <Typography variant="body2" color="textSecondary" className={classes.helperText}>
          Opcional
        </Typography>
        <TextField
          className={classes.reasonTextField}
          multiline
          rows={4}
          variant="outlined"
          value={reasonText}
          onChange={(e) => setReasonText(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Ex.: Ausente, conflito de interesses"
          autoFocus
          fullWidth
          inputProps={{
            maxLength: 150,
          }}
        />
        <Typography variant="caption" color="textSecondary" align="right">
          {reasonText.length}/150 characters
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={handleClose}
          className={classes.cancelButton}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          className={classes.submitButton}
          color="primary"
          variant="contained"
          disabled={reasonText.length > 150}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DialogVoteReason.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialReason: PropTypes.string,
};

DialogVoteReason.defaultProps = {
  initialReason: '',
};

export default DialogVoteReason;
